<template>
  <div class="kyc-container w-100 h-100">
    <div class="spacing-32"></div>
    <div class="spacing-32"></div>
    <div class="spacing-32"></div>
    <div
      v-if="$route.query.status === 'success'"
      class="success-container d-flex flex-column align-items-center justify-content-center"
    >
      <div>
        <page-header :title="$t('digilocker.status.success.heading')" />
      </div>
      <div class="spacing-24"></div>
      <div class="drip-h2 color-noble-blue-500 font-weight-700 text-center">
        {{ $t('digilocker.status.success.title') }}
      </div>
      <div class="spacing-8"></div>
      <div class="drip-h4 font-weight-400 w-50 text-center">
        {{ $t('digilocker.status.success.body') }}
      </div>
    </div>
    <div
      v-else
      class="failed-container d-flex flex-column align-items-center justify-content-center"
    >
      <div>
        <page-header :title="$t('digilocker.status.failed.heading')" />
      </div>
      <div class="spacing-24"></div>
      <div class="drip-h2 color-noble-blue-500 font-weight-700 text-center">
        {{ $t('digilocker.status.failed.title') }}
      </div>
      <div class="spacing-8"></div>
      <div class="drip-h4 font-weight-400 w-50 text-center">
        {{ $t('digilocker.status.failed.body') }}
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/components/common/PageHeader'

export default {
  components: { PageHeader },
  mounted() {
    this.$mpTrack('Digilocker - Status page mounted!')
    if (this.$route.query.status === 'success') {
      this.$mpTrack('Digilocker - Successfully completed KYC process', {
        requestId: this.$route.query.requestId || ''
      })
    } else {
      this.$mpTrack('Digilocker - Failed to verify KYC process', {
        error: this.$route.query.error,
        requestId: this.$route.query.requestId || ''
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.kyc-container {
  width: 100%;
  padding: 40px 108px;
  margin-bottom: 8px;
  @media screen and (max-width: 1200px) {
    padding: 40px 56px;
  }
  @media screen and (max-width: 768px) {
    padding: 40px 24px;
  }
}
</style>
